/**
 * Amplify Auth configuration (FE1 — login + shell).
 *
 * Reads the Cognito ids from Vite env vars, injected at build time by the
 * StaticSite (infra/app-web.ts) for deployed builds, or from a gitignored
 * `.env.local` for local `npm run dev`. Email/password only (Cognito SRP — our
 * app client already allows USER_SRP_AUTH); no hosted-UI / Google OAuth yet
 * (that's future — and would need the `enable-oauth-listener` import, see
 * docs/frontend-auth.md).
 *
 * `AMPLIFY_CONFIGURED` is the single gate the app keys off: false whenever the
 * ids are absent (e.g. local dev without the vars), so an unconfigured build
 * still renders instead of crashing on a half-configured Amplify.
 *
 * Ported from bento's app-web (lib/amplify.ts), trimmed to our email/password case.
 */

import { Amplify } from "aws-amplify";

const USER_POOL_ID = import.meta.env.VITE_USER_POOL_ID;
const USER_POOL_CLIENT_ID = import.meta.env.VITE_USER_POOL_CLIENT_ID;

/** True only when both Cognito ids are present — see the module comment. */
export const AMPLIFY_CONFIGURED = Boolean(USER_POOL_ID && USER_POOL_CLIENT_ID);

if (AMPLIFY_CONFIGURED) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: USER_POOL_ID as string,
        userPoolClientId: USER_POOL_CLIENT_ID as string,
      },
    },
  });
}
